import { useState } from "react";
import {
  MileageHistoryResponse,
  myMileage,
  myMileageLog,
  myPoint,
  myPointLog,
  PointHistoryResponse,
  WalletPubDto,
} from "../../../../api/member";
import { SeedHistoryResponse, mySeedLog, mySeed } from "../../../../api/seed";
import {
  getSubPrizeRewardLogList,
  SubPrizeRewardLogAppResponse,
} from "../../../../api/sub-prize";

const useWalletLogs = () => {
  const [point, setPoint] = useState(0);
  const date = new Date();
  const [month, setMonth] = useState(date.getMonth() + 1);
  const [year, setYear] = useState(date.getFullYear());
  const [pub, setPub] = useState<WalletPubDto | null>(null);
  const [seedLogs, setSeedLogs] = useState<SeedHistoryResponse[]>([]);
  const [pointLogs, setPointLogs] = useState<PointHistoryResponse[]>([]);
  const [mileageLogs, setMileageLogs] = useState<MileageHistoryResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const [subPrizeLogs, setSubPrizeLogs] = useState<
    SubPrizeRewardLogAppResponse[]
  >([]);

  const getSeedLogs = async () => {
    setLoading(true);
    try {
      await getSeed();
      const res = await mySeedLog(year, month);
      setSeedLogs(res);
    } catch (e) {
      console.error(e);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 80);
    }
  };

  const getSubPrizeLogs = async () => {
    if (!pub) return;
    setLoading(true);
    try {
      const res = await getSubPrizeRewardLogList(pub.id, year);
      setSubPrizeLogs(res);
      setPoint(res.length);
    } catch (e) {
      console.error(e);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 250);
    }
  };

  const getPointLogs = async () => {
    if (!pub) return;
    setLoading(true);
    try {
      await getPoint();
      const res = await myPointLog(year, month, pub?.id);
      setPointLogs(res);
    } catch (e) {
      console.error(e);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 250);
    }
  };

  const getMileageLogs = async () => {
    if (!pub) return;
    setLoading(true);
    try {
      await getMileage();
      const res = await myMileageLog(year, month, pub?.id);
      setMileageLogs(res);
    } catch (e) {
      console.error(e);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 250);
    }
  };

  const getSeed = () => {
    mySeed()
      .then((seed) => {
        setPoint(seed ? seed : 0);
      })
      .catch((e) => {
        setPoint(0);
      });
  };

  const getPoint = () => {
    if (!pub) return;
    myPoint(pub.id)
      .then((point) => {
        setPoint(point ? point : 0);
      })
      .catch((e) => {
        setPoint(0);
      });
  };

  const getMileage = () => {
    if (!pub) return;
    myMileage(pub.id).then((mileage) => {
      setPoint(mileage ? mileage : 0);
    });
  };

  return {
    // 로그 데이터
    seedLogs,
    pointLogs,
    mileageLogs,
    subPrizeLogs,
    // 시드 or 매장이용권 or 마일리지
    point,
    // 필터 (월, 년, 펍)
    month,
    setMonth,
    year,
    setYear,
    pub,
    setPub,
    // api 호출
    getSeedLogs,
    getPointLogs,
    getMileageLogs,
    getSubPrizeLogs,
    loading,
  };
};

export default useWalletLogs;
